/**
 * Wraps a lib-defined event handlers returning a single handler that allows
 * a user to prevent other handlers from firing.
 *
 * @param {function} handlers Event handlers executed in order
 * @returns {function} event handler
 */
export default function composeEventHandlers(...handlers) {
  return (event) => {
    handlers.filter(Boolean).every((h) => {
      h(event);
      if (event.defaultPrevented) {
        return false;
      }

      return true;
    });
  };
}
